import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  Text,
  Box,
  Link
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { formatDateTime } from '../../../helpers'
import { JobApplicationService } from '../../../services/JobApplication/JobApplicationService'
import { JobApplicationComplete } from '../../../services/JobApplication/types'

interface IProps {
  isOpen: boolean
  onClose: () => void
  id: number
}

export function JobApplicationViewModal({ isOpen, onClose, id }: IProps) {
  const service = new JobApplicationService()
  const [jobApplication, setJobApplication] = useState<JobApplicationComplete>()

  useEffect(() => {
    if (isOpen && jobApplication?.id !== id) {
      setJobApplication(undefined)

      service.get(id).then((response) => {
        setJobApplication(response)
      })
    }
  }, [id, isOpen])

  return jobApplication ? (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="3xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex justifyContent="space-between" alignItems="center">
            <Text fontWeight="normal">
              <strong>Candidato:</strong> {jobApplication?.name}
              <br />
              <strong>Vaga:</strong> {jobApplication?.job_position}
              <br />
              <strong>Áreas:</strong>{' '}
              {jobApplication?.area ? jobApplication?.area.join(', ') : <small>Não informado</small>}
            </Text>
            <Link
              href={`${
                process.env.REACT_APP_API_URL
              }api/website/job-application/resume/${id}/${jobApplication.name.replaceAll('/', '')}`}
              target="_blank"
            >
              <Button colorScheme="magenta" variant="outline" size="sm">
                Ver currículo
              </Button>
            </Link>
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Flex justifyContent="space-between" mb={4}>
            <Text>
              <strong>Telefone:</strong> {jobApplication?.phone}
            </Text>
            <Text>
              <strong>E-mail:</strong>{' '}
              <Link href={`mailto:${jobApplication?.email}`} color="blue.400" target="_blank">
                {jobApplication?.email}
              </Link>
            </Text>
          </Flex>
          <Box mb={4}>
            <Text fontWeight="bold">Por que você quer trabalhar na ABRA?</Text>
            <Text textAlign="justify">
              {jobApplication?.why_you_want_to_work_here ? (
                jobApplication?.why_you_want_to_work_here
              ) : (
                <small style={{ color: 'gray' }}>Não informado</small>
              )}
            </Text>
          </Box>
          <Box mb={4}>
            <Text fontWeight="bold">Cite alguns motivos para te contratarmos</Text>
            <Text textAlign="justify">
              {jobApplication?.reasons_to_hire_you ? (
                jobApplication?.reasons_to_hire_you
              ) : (
                <small style={{ color: 'gray' }}>Não informado</small>
              )}
            </Text>
          </Box>
          <Text textAlign="right" fontSize="sm">
            {jobApplication?.created_at ? formatDateTime(jobApplication.created_at) : ''}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose} type="button">
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ChakraModal>
  ) : (
    <></>
  )
}
